import driverService from '@/services/driver-service'

function getNewState() {
  return {
    categoriesChauffeur: [],
    sous_categoriesChauffeur: [],
  }
}

export default {
  state: getNewState(),
  getters: {
    getCategoriesChauffeur(state) {
      return state.categoriesChauffeur
    },
    getSousCategoriesChauffeur(state) {
      return state.sous_categoriesChauffeur
    },
  },
  mutations: {
    setCategoriesChauffeur(state, infos = []) {
      state.categoriesChauffeur = infos
    },
    setSousCategoriesChauffeur(state, infos = []) {
      state.sous_categoriesChauffeur = infos
    },
  },
  actions: {
    // async initializeDriver({state, commit}) {

    async initializeDriver({ commit }) {
      let driverCategories = await driverService.fetchDriverCategories(
        driverService.normalizeDriverCategoryToV2
      )

      let drivers = await driverService.fetchDrivers((d) => {
        return driverService.normalizeDriverToV2(d, driverCategories)
      })

      commit('setCategoriesChauffeur', driverCategories)
      commit('setSousCategoriesChauffeur', drivers)
    },
  },
}
